import { gql } from 'graphql-request'

export const CREATE_ADMIN = gql`
  mutation CreateAdmin($createAdminInputs: [CreateAdminInput!]!) {
    createAdmin(createAdminInputs: $createAdminInputs) {
      id
    }
  }
`
